import { render, staticRenderFns } from "./SectionAssetList.vue?vue&type=template&id=adbca850"
import script from "./SectionAssetList.vue?vue&type=script&lang=js"
export * from "./SectionAssetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports